const { en: globalCommon } = require("../../common");
const { en: plasmidsCommon } = require("../../plasmids-page");

module.exports = {
	...globalCommon,
	...plasmidsCommon,
	"plasmids-sequences": require("./plasmids-sequences.json"),
	"section-try-for-free": require("../../section-try-for-free/en/section-try-for-free.json"),
};
